// vendor
import { Injectable } from '@angular/core';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.state';

// local application
import { ProjectLocationsService } from 'app/services/project-locations.service';
import { ProjectLocationTypes } from './project-locations.type';
import * as projectLocationActions from './project-locations.action';
import { DialogActions } from 'app/store/global/dialog';

@Injectable()
export class ProjectLocationEffects {
  constructor(
    private actions$: Actions,
    private service: ProjectLocationsService,
    private store: Store<AppState>
  ) {}

  getProjectLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectLocationTypes.GET_PROJECT_LOCATIONS),
      switchMap(() =>
        this.service.fetchProjectLocations().pipe(
          map(({ data }) => {
            return projectLocationActions.getProjectLocationsSuccess(
              data.details
            );
          }),
          takeUntil(
            this.actions$.pipe(
              ofType(ProjectLocationTypes.GET_PROJECT_LOCATIONS_CANCEL)
            )
          ),
          catchError((error: unknown) => {
            this.store.dispatch(
              projectLocationActions.getProjectLocationsCancel()
            );
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );
}
